import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-flashlight-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-950">
              爆料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`ml-2 px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-secondary-100 text-secondary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer text-foreground-700 hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50/95 backdrop-blur-md py-3">
            <div className="max-w-7xl mx-auto flex flex-col gap-1 px-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2.5 text-sm rounded-lg transition-colors duration-200 cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={`${cat.icon} mr-2`}></i>
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-2.5 text-sm rounded-lg transition-colors duration-200 cursor-pointer ${
                  location.pathname === '/about'
                    ? 'bg-secondary-100 text-secondary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                <i className="ri-information-line mr-2"></i>
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}